// extracted by mini-css-extract-plugin
export default {"carousel":"heroContent_carousel__PgaQD","image":"heroContent_image__7XaHJ"};